
import CryptoJS from 'crypto-js';

const secretKey = process.env.REACT_APP_SECRET_ENCRYPT_KEY; // Use uma chave forte e secreta

// Função para criptografar
const encryptData = (data) => {
    const stringifiedData = JSON.stringify(data); // Converte o objeto para string
    return CryptoJS.AES.encrypt(stringifiedData, secretKey).toString();
};



// Função para descriptografar
const decryptData = (ciphertext) => {
    try{
        if(ciphertext){
            
            const bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
            return JSON.parse(bytes.toString(CryptoJS.enc.Utf8)); // Converte de volta para objeto

        } else {
            return null;
        }

    } catch (e) {
        return null;
    }
};


export {encryptData, decryptData};